import { combineReducers } from 'redux'
import {
  createRequestReducer,
  createReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizeContributors = data => {
  const contributor = new schema.Entity('contributors')
  return normalize(data, [contributor])
}

const normalizeInvitees = data => {
  const invitee = new schema.Entity('invitees')
  return normalize(data, [invitee])
}

const AssessmentFileReducer = combineReducers({
  fetchAssessmentFileRequest: createRequestReducer(
    'ASSESSMENT_FILE_STORE:FETCH',
    { pending: true }
  ),
  assessmentFile: createReducer(null, {
    'ASSESSMENT_FILE_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      response.data.assessment_file,
    'ASSESSMENT_FILE_STORE:EDIT_REQUEST_SUCCESS': (
      state,
      { response, params }
    ) => {
      return {
        ...state,
        title: params.title.title,
        context: params.title.context,
        moderation_type: params.title.moderation_type,
        judgement: params.title.judgement
      }
    },
    'DISCUSSION:MARK_AS_CONCLUSION_REQUEST_SUCCESS': state => {
      return {
        ...state,
        concluded: true
      }
    },
    'ASSESSMENT_FILE_STORE:FETCH_INVITEES_COUNTER_REQUEST_SUCCESS': (
      state,
      { response }
    ) => {
      return {
        ...state,
        guest_moderator_count:
          response.data.assessment_file.guest_moderator_count
      }
    },
    'DISCUSSION:SUBMIT_REQUEST_SUCCESS': state => {
      return {
        ...state,
        concluded: false
      }
    },
    'DISCUSSION:UNMARK_AS_CONCLUSION_REQUEST_SUCCESS': state => {
      return {
        ...state,
        concluded: false
      }
    },
    'ASSESSMENT_FILE_STORE:MARK_AS_EXAMPLE_REQUEST_SUCCESS': state => {
      return {
        ...state,
        example: true
      }
    },
    'ASSESSMENT_FILE_STORE:UNMARK_AS_EXAMPLE_REQUEST_SUCCESS': state => {
      return {
        ...state,
        example: false
      }
    },
    'ASSESSMENT_FILE_STORE:MARK_AS_TRAINING_MATERIAL_REQUEST_SUCCESS': state => {
      return {
        ...state,
        training_material: true
      }
    },
    'ASSESSMENT_FILE_STORE:UNMARK_AS_TRAINING_MATERIAL_REQUEST_SUCCESS': state => {
      return {
        ...state,
        training_material: false
      }
    },
    'ASSESSMENT_FILE_STORE:MARK_AS_BENCHMARK_REQUEST_SUCCESS': state => {
      return {
        ...state,
        benchmarked: true
      }
    },
    'ASSESSMENT_FILE_STORE:UNMARK_AS_BENCHMARK_REQUEST_SUCCESS': state => {
      return {
        ...state,
        benchmarked: false
      }
    },
    'ASSESSMENT_FILE_STORE:CLOSE_REQUEST_SUCCESS': state => {
      return {
        ...state,
        closed: true
      }
    },
    'ASSESSMENT_FILE_STORE:REOPEN_REQUEST_SUCCESS': state => {
      return {
        ...state,
        closed: false
      }
    },
    'ASSESSMENT_FILE_STORE:MARK_AS_PREMIUM_REQUEST_SUCCESS': state => {
      return {
        ...state,
        premium: true
      }
    },
    'ASSESSMENT_FILE_STORE:UNMARK_AS_PREMIUM_REQUEST_SUCCESS': state => {
      return {
        ...state,
        premium: false
      }
    }
  }),
  contributors: createReducer(null, {
    'ASSESSMENT_FILE_STORE:FETCH_REQUEST_SUCCESS': (state, { response }) =>
      normalizeContributors(response.data.assessment_file.contributors),
    'DISCUSSION:SUBMIT_REQUEST_SUCCESS': (state, { response }) => {
      if (state) {
        if (
          state.entities.contributors &&
          state.entities.contributors[response.data.actions[0].originator.id]
        ) {
          return state
        } else {
          return {
            ...state,
            result: [...state.result, response.data.actions[0].originator.id],
            entities: {
              contributors: {
                ...state.entities.contributors,
                [response.data.actions[0].originator.id]:
                  response.data.actions[0].originator
              }
            }
          }
        }
      } else {
        return normalizeContributors([])
      }
    }
  }),
  fetchInviteesRequest: createRequestReducer(
    'ASSESSMENT_FILE_STORE:FETCH_INVITEES',
    { pending: true }
  ),
  invitees: createReducer(null, {
    'ASSESSMENT_FILE_STORE:FETCH_INVITEES_REQUEST_SUCCESS': (
      state,
      { response }
    ) => {
      return normalizeInvitees(
        response.data.assessment_file.assessment_file_invitations
      )
    }
  }),
  invitationAssessmentDialog: createReducer(
    { opened: false },
    {
      'ASSESSMENT_FILE_STORE:INVITATION_ASSESSMENT_DIALOG:OPEN': (
        state,
        { params }
      ) => ({
        ...state,
        opened: true,
        id: params.id
      }),
      'ASSESSMENT_FILE_STORE:INVITATION_ASSESSMENT_DIALOG:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  ),
  editTitleDialog: createReducer(
    { opened: false },
    {
      'ASSESSMENT_FILE_STORE:EDIT_TITLE_DIALOG:OPEN': (state, { params }) => {
        return {
          ...state,
          opened: true,
          id: params.id,
          title: params.title,
          description: params.description,
          moderation_type: params.moderation_type,
          judgement: params.judgement
        }
      },
      'ASSESSMENT_FILE_STORE:EDIT_TITLE_DIALOG:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  ),
  inviteesDialog: createReducer(
    { opened: false },
    {
      'ASSESSMENT_FILE_STORE:INVITEES_DIALOG:OPEN': (state, { params }) => {
        return {
          ...state,
          opened: true,
          id: params.id
        }
      },
      'ASSESSMENT_FILE_STORE:INVITEES_DIALOG:CLOSE': state => ({
        ...state,
        opened: false
      })
    }
  )
})

export default AssessmentFileReducer
